import * as React from 'react';
export var formContext = React.createContext(null);
/** Provide form data through the form tree. */

export var FormContextProvider = formContext.Provider;
/** Consume form data through the form tree. */

export var FormContextConsumer = formContext.Consumer;